<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-card class="shadowCard">

    	<v-card-title class="text-subtitle-1">
    	  <span class="mr-2">Seguimiento NI</span>
        <v-spacer></v-spacer>

        
        <v-btn 
          class="mr-2" 
          small dark color="green"
          @click="exportExcel( filterProspectos  , 'SEGUIMIENTO_NI')"
          tile
        >
          <v-icon small>mdi-microsoft-excel</v-icon>
        </v-btn>

        <v-btn 
          v-if="getCCNNUsuario.idpuesto != 18"
          class="mr-2" 
          small dark color="red"
          tile
          @click="dialogRepote = true"
        >
          <v-icon left small>mdi-file-document-multiple</v-icon>
          Reporte
        </v-btn>


        <v-btn
          color="primary"
          dark
          class="text-capitalize"
          @click="initialize()"
          small
          tile
        >
          <v-icon left small>mdi-refresh</v-icon>
          Actualizar
        </v-btn>


    	</v-card-title>


      <!-- Buscador y filtros -->
      <v-card-text>
        <v-row >
          <v-col cols="12" md="6" lg="4" v-if="getCCNNUsuario.idpuesto != 18" class="pb-0">
            <v-autocomplete
              filled
              dense
              clearable
              v-model="vendedoraFiltro"
              :items="vendedoras"
              label="Selecciona la vendedora"
              persistent-hint
              hide-details
              item-text="nombre"
              item-value="iderp"
            >
            </v-autocomplete>
          </v-col>

          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="4" class="pb-0">
            <v-text-field
              v-model="search"
              dense
              filled
              label="Buscar"
              append-icon="mdi-magnify"
            ></v-text-field>  
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Tablas -->
      <v-card-text class="pt-0">

        <div class="text-h6">
          <b>Total: </b> {{ filterProspectos.length }}
          <br/>
          <b>Sin seguimiento: </b> {{ filterProspectos.filter( el => { return el.seguimiento_whatsApp > 3 }).length }}
          <br/>
          
        </div>

        <v-data-table
          :headers="headers"
          :items="filterProspectos"
          class="elevation-0"
          :search="search"
          dense
        >
          <!-- Datos dinámicos de las tablas -->
          <template v-slot:item.folio="{ item }">
            <span>
            	<strong>[ {{ item.folio }} ]</strong>
            	<br/>
            	{{ item.nombre_completo }}
            	<br/>
            	{{ item.whatsapp }}
            </span>
          </template>

          <template v-slot:item.idetapa="{ item }">
            <!-- chip para prospectos atrasados -->
            <v-tooltip bottom color="red" v-if="item.idetapa == 1">
              <template v-slot:activator="{ on, attrs }">
                <v-chip small  color="red" dark  v-bind="attrs" v-on="on">Atrasado</v-chip>
              </template>
              <span>El proespecto esta esperando que se contacten con el</span>
            </v-tooltip>

            <!-- chip para prospectos nuevos -->
            <v-tooltip bottom color="green" v-if="item.idetapa == 2">
              <template v-slot:activator="{ on, attrs }" v-if="item.idetapa == 2">
                <v-chip small  color="green"  dark  v-if="item.idetapa == 2" v-bind="attrs" v-on="on">Nuevo</v-chip>
              </template>
              <span>Prospecto llego hoy y no tiene información</span>
            </v-tooltip>

            <!-- chip para prospectos en inducción -->
            <v-tooltip bottom color="pink" v-if="item.idetapa == 3">
              <template v-slot:activator="{ on, attrs }" v-if="item.idetapa == 3">
                <v-chip small  color="pink"   dark  v-if="item.idetapa == 3" v-bind="attrs" v-on="on">
                	<v-icon v-if="item.dia_induccion == 1" color="yellow" left>mdi-bell</v-icon>Inducción
                </v-chip>
              </template>
              <span>El prospecto se encuentra en inducción</span>
            </v-tooltip>

            <!-- chip para prospectos en seguimiento con información -->
            <v-tooltip bottom color="orange" v-if="item.idetapa == 4">
              <template v-slot:activator="{ on, attrs }" v-if="item.idetapa == 4">
                <v-chip small  color="orange" dark  v-if="item.idetapa == 4" v-bind="attrs" v-on="on">Con Info</v-chip>
              </template>
              <span>Al prospecto ya se le brindo información</span> 
            </v-tooltip>

            <!-- chip para prospectos con información -->
            <v-tooltip bottom color="brown" v-if="item.idetapa == 5">
              <template v-slot:activator="{ on, attrs }" v-if="item.idetapa == 5">
                <v-chip small  color="brown"  dark  v-if="item.idetapa == 5" v-bind="attrs" v-on="on">Sin Info</v-chip>
              </template>
              <span>Al prospecto no se le ha podido brindar información</span>
            </v-tooltip>
          </template>

          <template v-slot:item.conmutador="{ item }">
            <!-- chip para prospectos atrasados -->
            <v-tooltip bottom :color=" item.conmutador.length ? 'green' : 'red' " >
              <template v-slot:activator="{ on, attrs }">
                <v-chip 
                	small 
                	:color=" item.conmutador.length ? 'green' : 'red' "
                	dark 
                	v-bind="attrs" 
                	v-on="on" 
                >
                  {{ item.conmutador.length ? 'SI' : 'NO' }}
                </v-chip>
              </template>
              <span v-if="item.conmutador.length">
                <span v-for="( mensaje, i ) in item.conmutador" :key="i">
                  {{ mensaje.mensaje }} 
                  <br/>
                </span> 
              </span>

              <span v-else>
                Sin llamadas en el conmutador.
              </span>

            </v-tooltip>
          </template>

          <template v-slot:item.llamadas_intentos="{ item }">
            <!-- chip para prospectos atrasados -->
            <v-tooltip bottom :color=" item.conmutador.length ? 'green' : 'red' " >
              <template v-slot:activator="{ on, attrs }">
                <v-chip 
                	small 
                	:color=" item.conmutador.length ? 'green' : 'red' "
                	dark 
                	v-bind="attrs" 
                	v-on="on" 
                >
                  {{ item.conmutador.length ? 'SI' : 'NO' }}
                </v-chip>
              </template>
              <span>
              	LLamadas > 3 min: {{ item.mastresmin }}
								<br/>
								contestadas:      {{ item.contestadas }}
								<br/>
								rechazadas:       {{ item.rechazadas }}
								<br/>
								ocupadas:         {{ item.ocupadas }}
								<br/>
								fallidas:         {{ item.fallidas }}
              </span>

            </v-tooltip>
          </template>

          <template v-slot:item.seguimiento_whatsApp="{ item }">
          	<v-tooltip bottom 
          		:color="item.seguimiento_whatsApp > 3 || !item.ultimo_mensaje ? 'red' : 'green' "
          	>
				      <template v-slot:activator="{ on, attrs }">
		            <v-chip
                	:color="item.seguimiento_whatsApp > 3 || !item.ultimo_mensaje ? 'red' : 'green' "
                	dark
		              dark
		              small
				          v-bind="attrs"
				          v-on="on"
		            >
                	{{ item.seguimiento_whatsApp > 3 || !item.ultimo_mensaje ? 'NO' : 'SI' }}
		            </v-chip>
				      </template>

				      <span v-if="item.seguimiento_whatsApp > 3 && item.ultimo_mensaje">
				      	Al alumno no se le ha brindado ningúna información por whatsApp desde hace {{ item.seguimiento_whatsApp }} días
				      </span>

				      <span v-if="item.seguimiento_whatsApp <= 3 && item.ultimo_mensaje ">
				      	Seguimiento correcto del alumno
				      </span>

				      <br v-if="item.ultimo_mensaje"/>

				      <span>
				      	{{ item.ultimo_mensaje ? 'último mensaje: ' + item.ultimo_mensaje : 'No tiene mensajes'}}
				      </span>
				    </v-tooltip>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Actualizar
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>   
    </v-card>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <v-dialog
      v-model="dialogRepote"
      persistent
      max-width="600"
    >
      <v-card>
        <!-- PAGO OFICIAL -->
        <v-card-title>
          <span class="text-body-1"><b>Reporte seguimiento</b></span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text >
          <v-subheader class="pl-0 black--text">FAST</v-subheader>
          <v-data-table
            :headers="headersReporte"
            :items="reporteFast"
            class="elevation-0"
            dense
            hide-default-footer
          >
          </v-data-table>

          <v-divider class="mt-6"></v-divider>

          <v-subheader class="pl-0 black--text">INBI</v-subheader>
          <v-data-table
            :headers="headersReporte"
            :items="reporteInbi"
            class="elevation-0"
            dense
            hide-default-footer
          >
          </v-data-table>

        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="dialogRepote = false"
            rounded
            color="red"
            dark
            class="text-capitalize"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <!-- Dialog de carga -->
      <Alerta               v-if="respuestaAlerta"          :parametros="parametros"/>
      <carga                v-if="cargar"/>
    </v-dialog>
   
  </v-container>
</template>

<script>
import axios from 'axios';
  import { headerAdmin, headerVend, headerSeguimiento } from '@/views/crm-prospectos/prospectos/headerTablas'
  import { mapGetters, mapActions }  from 'vuex';

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  // Mixins
  import funciones       from '@/mixins/funcionesProspectos'
  import catalagos       from '@/mixins/catalagos'
  import funcionesExcel  from '@/mixins/funcionesExcel'
  import validarErrores  from '@/mixins/validarErrores'

  var moment  = require('moment');
  moment.locale(); 

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [funciones,catalagos,funcionesExcel,validarErrores],

    data: () => ({
      // herramientas visuales
      estatusFiltro:6,

      // Tabla
      headers: [],

      // Prospectos
      prospectos:     [], //arreglo
      
      vendedoras:[],
      vendedoras_plantel:[],
      vendedora:null,
      nombreVendedora:'',

      vendedoraFiltro:null,
     
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      search:'',

      headersReporte: [
        { text: 'Vendedora'        , value: 'vendedora'      },
        { text: 'Sin seguimeinto'  , value: 'sinseguimiento' },
        { text: 'Total'            , value: 'contador'       },
      ],
      reporteFast:[],
      reporteInbi:[],
      dialogRepote: false
      
    }),

    computed: {
      ...mapGetters('login', ['getCCNNUsuario', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      filterProspectos(){
      	if(this.vendedoraFiltro){
      		return this.prospectos.filter( el => { return el.usuario_asignado == this.vendedoraFiltro })
	      }else{ return this.prospectos }
      },
    
    },

    async created() {
      // Agregamos los header de la tabla
      this.headers = headerSeguimiento
      await this.getVendedoras()
      await this.initialize();
    },

    methods: {
      ...mapActions('login', ['cambiarDrawer','cambiarEstatusLlamada','addTareas','traerProspectosNuevos']),

      // Inicio de todo
      initialize() {
        // Abrimos modal de carga
        this.cargar = true
        // Limpiamos los prospectos
        this.prospectos  = []

        // Ver el tipo de usuario que entrara
        let tipo = 0 // null
        if(this.getCCNNUsuario.idpuesto == 18){
          tipo = 1 // vendedora
        }else{
          tipo = 2 // Director
        }
        
        return this.$http.get('prospectos.seguimiento/' + tipo + '/' + this.getCCNNUsuario.iderp).then((response) => {
          // Filtramos los que necesitamos, depende si es vendedora o administrador
          this.prospectos  = response.data.nuevos
          this.reporteFast = response.data.arregloVendedorasFast
          this.reporteInbi = response.data.arregloVendedorasInbi

          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },
    },
  };
</script>
